import React from 'react';
import PropTypes from 'prop-types';
// import get from 'lodash/get';
import {
  Label,
} from 'react-bootstrap';

const generateCustomizable = (Element) => {
  const CustomizableElement = ({ children, ...props }) =>
    /*
    let customStyle = get(props, 'style', {});
    const active = props.active || 'btn-success';
    if (get(props, 'className', '').indexOf(active) >= 0) {
      customStyle = {
        backgroundColor: get(ui, 'widget.options.highlight_color', '#4AAA48'),
        borderColor: get(ui, 'widget.options.highlight_color', '#4cae4c'),
      };
    }
    */
     (
       <Element
         {...props}
       >{children}</Element>
    );
  CustomizableElement.propTypes = {
    ui: PropTypes.any,
    active: PropTypes.string,
    children: PropTypes.element,
  };
  return CustomizableElement;
};

const CustomizableLinkButton = generateCustomizable('a');

const CustomizableButton = generateCustomizable('button');

const CustomizableTr = generateCustomizable('tr');

const CustomizableLabelBootstrap = generateCustomizable(Label);


export {
  CustomizableLinkButton,
  CustomizableButton,
  CustomizableTr,
  CustomizableLabelBootstrap,
};
